import PageHeader from './PageHeader';

export default (props) => <PageHeader {...props} />;
